export function isRowDisabled(
    isCodat: boolean,
    codatAccountId?: string | null,
) {
    return isCodat && !codatAccountId;
}
